import React, { useEffect, useState } from "react";
import Category from "src/business-types/laundry/modules/home/Category/Category";
import { PageTitle } from "src/shared/PageTitle";
import { useUser } from "src/shared/context/UserContext";
import SubscriptionDialog from "src/shared/modules/admin/auth/components/SubscriptionDialog";
import { pageTitle } from "src/shared/utils/brand";

function Home() {
  const { subscriptionInfo } = useUser();
  const [showDialog, setShowDialog] = useState(false);
  const [message, setMessage] = useState<React.ReactNode>("");
  const [isExpired, setIsExpired] = useState(false);
  const [,setfontfamily]= useState("");
  const { user } = useUser();

  useEffect(() => {
    document.title = pageTitle("Home");
    const fontfamily = user?.themes.fontFamily;
    if (fontfamily) {
      setfontfamily(fontfamily)
    }
  }, []);

  useEffect(() => {
    if (!subscriptionInfo) return;

    const alreadyShown = sessionStorage.getItem("subscription_dialog_shown");
    if (alreadyShown === "true") return;

    // GRACE PERIOD CASE
    if (subscriptionInfo.status === "grace_period") {
      const days = subscriptionInfo.daysRemaining;

      const formattedMessage = (
        <>
          This is a reminder that your current subscription will expire in <strong>{days} day(s)</strong>. Please renew now to avoid service disruption.
        </>
      );

      setMessage(formattedMessage);
      setIsExpired(false);
      setShowDialog(true);
      sessionStorage.setItem("subscription_dialog_shown", "true");
      return;
    }

    // WARNING CASE
    if (subscriptionInfo.warning) {
      setMessage(subscriptionInfo.warning);
      setShowDialog(true);
      sessionStorage.setItem("subscription_dialog_shown", "true");
      return;
    }
  }, [subscriptionInfo]);

  return (
    <div className="flex flex-col overflow-hidden w-full">
      {/* <PageTitle title="- Point of Sale › Home" /> */}

      <div className="w-full h-full">
        <Category />
        <SubscriptionDialog
          open={showDialog}
          message={message}
          isExpired={isExpired}
          onClose={() => setShowDialog(false)}
          onRenew={() => {
            setShowDialog(false);
          }}
        />
      </div>
    </div>
  );
}

export default Home;
